import front from "../images/example-images/front.jpg";
import right from "../images/example-images/right.jpg";
import left from "../images/example-images/left.jpg";
import back from "../images/example-images/back.jpg";
import mileage from "../images/example-images/mileage.jpg";

export const data = [
  {
    id: "front",
    label:
      "Show us what your vehicle looks like to help us give you the most accurate valuation.",
    helperText: "a view from the front.",
    image: front,
    showPreviewImage: true,
    tag: "Vehicle introduction",
    imageQuantityRequired: 1,
    boldLabelText: "front",
    singlePhotoUploadMore: false
  },
  {
    id: "right",
    label: "Let's get a look at your vehicle from another angle...",
    helperText: "a view from the right side of the vehicle.",
    image: right,
    showPreviewImage: true,
    tag: "Vehicle introduction",
    imageQuantityRequired: 1,
    boldLabelText: "right",
    singlePhotoUploadMore: false
  },
  {
    id: "left",
    label: "Let's get a look at your vehicle from another angle...",
    helperText: "a view from the left side of the vehicle.",
    image: left,
    showPreviewImage: true,
    tag: "Vehicle introduction",
    imageQuantityRequired: 1,
    boldLabelText: "left",
    singlePhotoUploadMore: false
  },
  {
    id: "back",
    label: "Let's get a look at your vehicle from another angle...",
    helperText: "a view from the back of the vehicle.",
    image: back,
    showPreviewImage: true,
    tag: "Vehicle introduction",
    imageQuantityRequired: 1,
    boldLabelText: "back",
    singlePhotoUploadMore: false
  },
  {
    id: "mileage",
    label: "Now we need to review the vehicle's mileage.",
    helperText: "a photo of the vehicle's mileage.",
    image: mileage,
    showPreviewImage: true,
    tag: "Vehicle introduction",
    imageQuantityRequired: 1,
    boldLabelText: "mileage",
    singlePhotoUploadMore: false
  }
];

export const MinPhotosRequired = data.length;
